import { DndProvider } from "react-dnd";
import LeadBoard from "../../components/FleetCRM/LeadBoard/LeadBoard";
import { HTML5Backend } from "react-dnd-html5-backend";
import { Box, Button, Typography } from "@mui/material";
import { useState } from "react";
import dayjs from "dayjs";
import ExcelUploadPopup from "../../components/Fleet/ExcelUploadPopup/ExcelUploadPopup";
import CreateLeadPopup from "../../components/FleetCRM/LeadBoard/CreateLeadPopup/CreateLeadPopup";
import RemindersTable from "../../components/FleetCRM/RemindersTable/RemindersTable";
import ReminderPopup from "../../components/FleetCRM/ReminderPopup/ReminderPopup";

const CRMBoardPage = () => {
  const [isExcelOpen, setIsExcelOpen] = useState(false);
  const [currentDate, setCurrentDate] = useState(dayjs());

  const handlePrev = () => setCurrentDate((d) => d.subtract(1, "month"));
  const handleNext = () => setCurrentDate((d) => d.add(1, "month"));

  return (
    <DndProvider backend={HTML5Backend}>
      <Box
        sx={{
          flexWrap: { xs: "wrap", lg: "nowrap" },
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <CreateLeadPopup />
        <Button
          sx={{
            marginLeft: 2,
          }}
          variant="contained"
          onClick={() => setIsExcelOpen(true)}
        >
          Upload Leads
        </Button>
      </Box>

      <ExcelUploadPopup
        open={isExcelOpen}
        onClose={() => setIsExcelOpen(false)}
        fileType="lead"
      />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <ReminderPopup />
        <RemindersTable />
      </Box>
      <Box
        sx={{
          flexWrap: { xs: "wrap", lg: "nowrap" },
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          mt: 2,
        }}
      >
        <Button onClick={handlePrev}>Previous</Button>
        <Typography sx={{ mx: 2 }}>
          {currentDate.format("MMMM YYYY")}
        </Typography>
        <Button onClick={handleNext}>Next</Button>
      </Box>
      <LeadBoard month={currentDate.month() + 1} year={currentDate.year()} />
    </DndProvider>
  );
};

export default CRMBoardPage;
